import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IParamsGetAccounts,
  IPayloadDeleteAccount,
  IResponseGetAccount,
  IResponseGetAccounts,
  IResponseGetNotifications,
  IResponseGetSelectAccounts,
} from '~/utils/interface/account';
import { IResponseAccount, IAccount } from '~/utils/interface/account';

const accountApi = {
  getSelectAccounts() {
    return axiosClient.get<IApiBaseResponse<IResponseGetSelectAccounts>>('/api/admin/accounts/selection');
  },

  createAccount(data: IAccount) {
    return axiosClient.post<IApiBaseResponse<IResponseAccount>>('/api/admin/accounts', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getAccounts(params: IParamsGetAccounts) {
    const url = `/api/admin/accounts`;
    return axiosClient.get<IApiBaseResponse<IResponseGetAccounts>>(url, { params });
  },
  getAccount(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetAccount>>(`/api/admin/accounts/${id}`);
  },
  updateAccount(id: string, data: IAccount) {
    return axiosClient.put<IApiBaseResponse<IResponseAccount>>(`/api/admin/accounts/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteAccount(data: IPayloadDeleteAccount) {
    const url = `/api/admin/accounts`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  getNotifications(idUser: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetNotifications>>(`/api/employees/${idUser}/notifications`);
  },

  markAsRead(idUser: string, idNotification: string, data: { readAt: string }) {
    return axiosClient.put<IApiBaseResponse<any>>(`/api/employees/${idUser}/notifications/${idNotification}/readed`, data);
  },
};

export default accountApi;
